import { useEffect, useState } from "react";
import { demoLogin, getConfig } from "../api/endpoints";
import type { Role } from "../types";
import OpenInTelegram from "./OpenInTelegram";

// Демо-роли для входа на сайте (когда нет Telegram). Совет: войти как «Админ» —
// тогда внутри доступно переключение «Просматривать как» между всеми ролями.
const DEMO_ROLES: { role: Role; label: string; hint: string }[] = [
  { role: "client",  label: "Клиент",   hint: "Каталог, избранное, покупка" },
  { role: "manager", label: "Менеджер", hint: "Выдача заказов, смены" },
  { role: "owner",   label: "Владелец", hint: "Аналитика и продажи" },
  { role: "admin",   label: "Админ",    hint: "Все роли + пользователи" },
];

// Экран входа для сайта (вне Telegram). Сейчас — демо-вход под ролью; позже сюда
// встанет Telegram Login Widget (cookie-сессия и всё остальное не изменятся).
export default function WebLogin({ onDone }: { onDone: () => void }) {
  const [cfg, setCfg] = useState<{ demo_login: boolean } | null>(null);
  const [busy, setBusy] = useState<Role | null>(null);

  useEffect(() => {
    getConfig()
      .then((c) => setCfg({ demo_login: c.demo_login }))
      .catch(() => setCfg({ demo_login: false }));
  }, []);

  const enter = async (role: Role) => {
    setBusy(role);
    try {
      await demoLogin(role);
      onDone();
    } catch {
      setBusy(null);
    }
  };

  // Конфиг ещё не загружен — лёгкая заглушка без мигания.
  if (!cfg) return <div className="splash"><div className="splash__brand">Storosilov<br />Vintage</div></div>;

  // Демо-вход выключен (прод без TG Login) — показываем подсказку про Telegram.
  if (!cfg.demo_login) return <OpenInTelegram />;

  return (
    <div className="splash" style={{ justifyContent: "center" }}>
      <div className="splash__brand" style={{ animation: "none", marginBottom: 4 }}>
        Storosilov<br />Vintage
      </div>
      <p className="micro" style={{ color: "var(--hint)", margin: 0 }}>
        Демо-вход
      </p>
      <div style={{ display: "grid", gap: 10, width: "100%", maxWidth: 360, marginTop: 8 }}>
        {DEMO_ROLES.map(({ role, label, hint }) => (
          <button
            key={role}
            className="btn btn--secondary"
            disabled={busy !== null}
            onClick={() => enter(role)}
            style={{ textAlign: "left", padding: "12px 16px", opacity: busy && busy !== role ? 0.5 : 1 }}
          >
            <span style={{ fontWeight: 700 }}>{busy === role ? "Входим…" : label}</span>
            <span className="micro" style={{ display: "block", color: "var(--hint)", marginTop: 3 }}>
              {hint}
            </span>
          </button>
        ))}
      </div>
      <p style={{ color: "var(--hint)", fontSize: 12, maxWidth: 320, lineHeight: 1.5, marginTop: 12 }}>
        Это демонстрационный вход без реального Telegram. В боевой версии — вход через Telegram.
      </p>
    </div>
  );
}
